// import { clientEnv, nodeEnvironment } from "@/config/clientEnv";
import { NodeEnvironment } from "@/domains/common/types";
import {
  DATADOG_LOGGING_CLIENT_TOKEN,
  DATADOG_SITE,
  DATADOG_WEB_SERVICE_NAME,
} from "@/domains/datadog/constants";
import { getBackendAnalyticsBaseUrl } from "@/manager/backend-api-client/initializeBackendApiManager";
import { clientEnvModule } from "@/modules/client-env";
import { IS_VARIANT_DEPLOYMENT } from "@/modules/global-state/isVariantDeployment";
import { datadogLogs } from "@datadog/browser-logs";

/**
 * Matches the site name of our datadog instance.
 */

export const initializeDatadogLoggingClient = async () => {
  const nodeEnv = clientEnvModule.nodeEnv();
  const packageVersion = clientEnvModule.packageVersion();
  const { buildInfo } = clientEnvModule.buildInfo();
  const version = `${packageVersion}-${buildInfo.gitCommitSha}`;

  // Use silent handler for variant deployments (no data sent)
  const handler = IS_VARIANT_DEPLOYMENT ? "silent" : undefined;

  datadogLogs.init({
    clientToken: DATADOG_LOGGING_CLIENT_TOKEN,
    site: DATADOG_SITE,
    version,
    forwardErrorsToLogs: !IS_VARIANT_DEPLOYMENT,
    service: DATADOG_WEB_SERVICE_NAME,
    sessionSampleRate: IS_VARIANT_DEPLOYMENT ? 0 : 100,
    env: nodeEnv,
    proxy: `${getBackendAnalyticsBaseUrl()}/v2/analytics/datadog/proxy`,
  });

  /**
   * For variant deployments, use silent handler.
   * For non-production, use console logger.
   * Otherwise, use default (http) handler.
   */
  if (IS_VARIANT_DEPLOYMENT) {
    datadogLogs.logger.setHandler("silent");
  } else if (nodeEnv !== NodeEnvironment.Production) {
    datadogLogs.logger.setHandler("console");
  }

  return datadogLogs;
};
